import React, { useState } from 'react';
import './RegisterInterestForm.css'; // Create this file for styling

function RegisterInterestForm() {
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: ''
  });
  const [consent, setConsent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!consent) {
      setError('Please agree to receive updates to continue');
      return;
    }
    
    setLoading(true);
    setError('');
    setSuccess('');
    
    console.log("Submitting form to /api/register-interest:", formData);
    
    try {
      // Test the debug endpoint first
      const debugResponse = await fetch('/api/debug');
      const debugData = await debugResponse.json();
      console.log("Debug endpoint response:", debugData);
      
      // Proceed with the actual registration
      const response = await fetch('/api/register-interest', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      
      console.log("Registration response status:", response.status);
      
      let data;
      try {
        data = await response.json();
        console.log("Registration response data:", data);
      } catch (parseError) {
        console.error("Error parsing response:", parseError);
        const responseText = await response.text();
        console.log("Raw response:", responseText);
        throw new Error("Invalid response format");
      }
      
      if (response.ok) {
        setSuccess(data.message || "Thanks for joining our mailing list! You'll be notified when we launch new features.");
        setFormData({ email: '', firstName: '', lastName: '' });
        setConsent(false);
      } else {
        setError(data.error || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      setError('Unable to register at this time. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-interest-container">
      <h2>Get Early Access</h2>
      <p>Sign up to be notified when we launch new features!</p>
      
      {success && <div className="success-message">{success}</div>}
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email Address*</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="your@email.com"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            placeholder="First Name"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            placeholder="Last Name"
          />
        </div>
        
        <div className="form-group consent-check">
          <input
            type="checkbox"
            id="consent"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            required
          />
          <label htmlFor="consent">
            I agree to receive updates about SlickPicks features and predictions.
            You can unsubscribe at any time.
          </label>
        </div>
        
        <button 
          type="submit" 
          className="submit-button"
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Sign Up'}
        </button>
      </form>
    </div>
  );
}

export default RegisterInterestForm; 